import styled, { css } from 'styled-components';

import { grey1 } from 'approot/shared/styles/colours.style';
import { mediaUp, rem } from 'approot/shared/style';
import {
  borderRadius16,
  boxShadow815Grey,
} from 'approot/shared/styles/borders.style';
import {
  spacing4,
  spacing16,
  spacing24,
  spacing40,
} from 'approot/shared/styles/spacing.style';
import { flexRightAlignCss } from 'approot/shared/styles/flex.style';
import { ACTIVITY_BUILDER_A4_LONG_SIDE } from 'approot/activity-builder/activity-builder.constants';
import { Box } from 'approot/shared/design-system/box/box.style';

export const CLOSE_BUTTON_HEIGHT = 40;

export const ACTIVITY_SHEET_CONTENT_MAX_WIDTH =
  ACTIVITY_BUILDER_A4_LONG_SIDE - 48;

type ActivitySheetContentProps = {
  $hasBanner?: boolean;
};
export const ActivitySheetContent = styled.div<ActivitySheetContentProps>`
  border-radius: ${rem(borderRadius16)} ${rem(borderRadius16)} 0 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  height: calc(100% - ${CLOSE_BUTTON_HEIGHT}px);

  ${({ $hasBanner }) =>
    $hasBanner &&
    `
      border-radius: 0;
    `}
`;

type ActivitySheetScrollableProps = {
  $backgroundColor?: string;
};
export const ActivitySheetScrollable = styled.div<ActivitySheetScrollableProps>`
  background-color: ${({ $backgroundColor = grey1 }) => $backgroundColor};
  flex-grow: 1;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
`;

export const ActivitySheetInnerContent = styled.div`
  padding: ${rem(spacing24)};
  ${mediaUp.md`
    padding: ${rem(spacing40)};
  `}
`;

type ActivitySheetInnerMaxProps = {
  $center?: boolean;
};
export const ActivitySheetInnerMax = styled.div<ActivitySheetInnerMaxProps>`
  margin: ${({ $center = true }) => ($center ? 'auto' : '0')};
  max-width: ${rem(ACTIVITY_SHEET_CONTENT_MAX_WIDTH)};
`;

export const ActivitySheetGridMax = styled.div`
  margin: auto;
  max-width: ${rem(1192)};
`;

type ActivitySheetCloseButtonProps = {
  $hasBanner?: boolean;
};
export const ActivitySheetCloseButton = styled.div<ActivitySheetCloseButtonProps>`
  ${flexRightAlignCss}

  border-radius: ${rem(40)};

  ${({ $hasBanner }) =>
    $hasBanner
      ? css`
          ${boxShadow815Grey}
          position: absolute;
          right: ${rem(spacing4)};
          z-index: 1;
        `
      : `
      margin-bottom: ${rem(spacing4)};
    `}
`;

export const ActivitySheetCustomActions = styled(Box).attrs({
  $justifyContent: 'flex-end',
  $gap: spacing16,
})`
  padding: ${rem(spacing4)};
`;
